import React from 'react'
import { Link } from 'react-router-dom'
import Details_1 from '../../../assets/images/blog/blog-details-1.jpg'
import Details_2 from '../../../assets/images/blog/blog-details-2.jpg'
import Details_3 from '../../../assets/images/services/service-details-pre.svg'
import Details_4 from '../../../assets/images/services/service-details-next.svg'
import Details_5 from '../../../assets/images/blog/blog-details-3.jpg'
import Details_6 from '../../../assets/images/blog/blog-details-4.jpg'
import Details_7 from '../../../assets/images/blog/blog-details-5.jpg'
import Details_8 from '../../../assets/images/svg/header/Search.svg'
import Details_9 from '../../../assets/images/blog/blog-single-5.jpg'
import Details_10 from '../../../assets/images/blog/blog-single-6.jpg'
import Details_11 from '../../../assets/images/blog/blog-single-7.jpg'
import Details_12 from '../../../assets/images/blog/blog-single-8.jpg'
import Details_13 from '../../../assets/images/blog/blog-single-9.jpg'
import Details_14 from '../../../assets/images/blog/blog-single-10.jpg'
import Details_15 from '../../../assets/images/blog/blog-single-11.jpg'

const Details = () => {
    return (
        <>
            <div className="blog-single-section">
                <div className="container">
                    <div className="row gutter-y-40">
                        <div className="col-lg-8">
                            <div
                                className="blog-list-box animate fadeInLeft wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="200ms"
                            >
                                <h4>Quality Websites</h4>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
                                    ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                    aliquip ex ea commodo consequat.
                                </p>
                            </div>
                            <div
                                className="blog-list-box animate fadeInLeft wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="300ms"
                            >
                                <h4>Management Style</h4>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
                                    ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                    aliquip ex ea commodo consequat. Duis aute irure dolor in
                                    reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                                    pariatur. Excepteur sint occaecat cupidatat non proident.
                                </p>
                                <div className="blog-detail-image">
                                    <div className="image">
                                        <img
                                            src={Details_1}
                                            alt="blog-image"
                                        />
                                    </div>
                                    <div className="image">
                                        <img
                                            src={Details_2}
                                            alt="blog-image"
                                        />
                                    </div>
                                </div>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
                                    ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                    aliquip ex ea commodo consequat. Duis aute irure dolor in
                                    reprehenderit.
                                </p>
                            </div>
                            <div
                                className="blog-list-box animate fadeInLeft wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="400ms"
                            >
                                <h4>If you are making mistakes</h4>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
                                    ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                    aliquip ex ea commodo consequat. Duis aute irure dolor in
                                    reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                                    pariatur. Excepteur sint occaecat cupidatat non proident.
                                </p>
                                <p className="cta-blog-details">
                                    “ Vulputate mi sit amet mauris commodo quis imperdiet. Metus
                                    vulputate eu felis imperdiet proin nulla aliquet enim. ”
                                </p>
                            </div>
                            <div
                                className="blog-list-box animate fadeInLeft wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="500ms"
                            >
                                <h4>Business Growth</h4>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
                                    ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                    aliquip ex ea commodo consequat. Duis aute irure dolor in
                                    reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                                    pariatur. Excepteur sint occaecat cupidatat non proident.
                                </p>
                                <ul className="blog-details-list">
                                    <li>
                                        <span>+</span> Maintaining The Personality
                                    </li>
                                    <li>
                                        <span>+</span> Design Development
                                    </li>
                                    <li>
                                        <span>+</span> Systematic Meeting{" "}
                                    </li>
                                    <li>
                                        <span>+</span> Employee Maintenance
                                    </li>
                                </ul>
                                <p>
                                    At vero eos et accusamus et iusto odio dignissimos ducimus qui
                                    blanditiis praesentium voluptatum deleniti atque corrupti quos
                                    dolores et quas molestias excepturi iusto odio dignissimos ducimus
                                    qui blanditiis praesentium voluptatum deleniti atque corrupti quos
                                    dolores et quas molestias excepturi sint occaecati cupiditate non
                                    provident, similique sunt in culpa qui officia deserunt mollitia
                                    animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis
                                    est et expedita distinctio.
                                </p>
                            </div>
                            <div
                                className="blog-list-box animate fadeInLeft wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="600ms"
                            >
                                <div className="blog-details-share">
                                    <div className="blog-tag">
                                        <ul>
                                            <li>
                                                <Link to="#">Marketing</Link>
                                            </li>
                                            <li>
                                                <Link to="#">Business</Link>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="blog-share">
                                        <ul className="share-social-media">
                                            <li>
                                                <Link to="https://www.facebook.com/">
                                                    <i className="fa-brands fa-facebook-f" />
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="https://x.com/">
                                                    <i className="fa-brands fa-twitter" />
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="https://www.instagram.com/">
                                                    <i className="fa-brands fa-instagram" />
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="https://in.linkedin.com/">
                                                    <i className="fa-brands fa-linkedin-in" />
                                                </Link>
                                            </li>
                                        </ul>
                                        <Link to="#">
                                            <i className="fa-solid fa-share-nodes" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="blog-list-box animate fadeInLeft wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="700ms"
                            >
                                <div className="blog-pagination-list">
                                    <div className="blog-pagination pre">
                                        <div className="blog-pagination-inner">
                                            <Link to="#">
                                                <img
                                                    src={Details_3}
                                                    alt="icon"
                                                />
                                                <span>Previous</span>{" "}
                                            </Link>
                                            <h5>
                                                {" "}
                                                <Link to="#">
                                                    Tracking Global News and Globalizat Global News
                                                </Link>
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="blog-pagination next">
                                        <div className="blog-pagination-inner">
                                            <Link to="#">
                                                <span>Next</span>
                                                <img
                                                    src={Details_4}
                                                    alt="icon"
                                                />
                                            </Link>
                                            <h5>
                                                <Link to="#">
                                                    Your brand is promise to your custom brand is promise
                                                </Link>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="blog-list-box animate fadeInLeft wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="800ms"
                            >
                                <div className="comment-box">
                                    <h4>Comments</h4>
                                    <div className="comment-box-item">
                                        <img
                                            src={Details_5}
                                            alt="comment-image"
                                        />
                                        <div className="comment-box-details">
                                            <div className="comment-meta-inner">
                                                <div className="comment-meta">
                                                    <p>John Mathew</p>
                                                    <span>Sep 24, 2024, at 10:45 am</span>
                                                </div>
                                                <Link to="#" className="btn btn-primary btn-theme">
                                                    Reply
                                                </Link>
                                            </div>
                                            <div className="comment-text">
                                                <p>
                                                    Our achievements are rooted in fostering deep collaboration
                                                    and cultivating a global community of diverse individuals
                                                    who are dedicated.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="comment-box-item reply">
                                        <img
                                            src={Details_6}
                                            alt="comment-image"
                                        />
                                        <div className="comment-box-details">
                                            <div className="comment-meta-inner">
                                                <div className="comment-meta">
                                                    <p>Alina. R</p>
                                                    <span>Aug 28, 2024, at 10:45 am</span>
                                                </div>
                                                <Link to="#" className="btn btn-primary btn-theme">
                                                    Reply
                                                </Link>
                                            </div>
                                            <div className="comment-text">
                                                <p>
                                                    Achievements are rooted in fostering deep collaboration and
                                                    cultivating a global community of diverse individuals who
                                                    are dedicated.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="comment-box-item">
                                        <img
                                            src={Details_7}
                                            alt="comment-image"
                                        />
                                        <div className="comment-box-details">
                                            <div className="comment-meta-inner">
                                                <div className="comment-meta">
                                                    <p>Jackson. K</p>
                                                    <span>Sep 05, 2024, at 10:45 am</span>
                                                </div>
                                                <Link to="#" className="btn btn-primary btn-theme">
                                                    Reply
                                                </Link>
                                            </div>
                                            <div className="comment-text">
                                                <p>
                                                    Rooted in fostering deep collaboration and cultivating a
                                                    global community of diverse individuals who are dedicated.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="comment-form-box animate fadeInLeft wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="900ms"
                            >
                                <h4>Leave A Comment</h4>
                                <p>
                                    Your email address will not be published. Required fields are marked
                                    *
                                </p>
                                <form action="#">
                                    <div className="comment-form-group-one">
                                        <div className="comment-form-group-one-inner">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Name"
                                                required=""
                                            />
                                        </div>
                                        <div className="comment-form-group-one-inner">
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Email"
                                                required=""
                                            />
                                        </div>
                                    </div>
                                    <div className="comment-form-group-one">
                                        <textarea
                                            name="comment"
                                            rows={4}
                                            className="form-control"
                                            placeholder="Comments"
                                            required=""
                                            defaultValue={""}
                                        />
                                    </div>
                                    <button type="submit" className="btn btn-secondary btn-theme">
                                        Leave A comment
                                    </button>
                                </form>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="blog-sidebar">
                                <div
                                    className="blog-block animate fadeInRight wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="200ms"
                                >
                                    <div className="blog-serch-widget">
                                        <form action="#">
                                            <input type="search" placeholder="Search Here ... " />
                                            <button type="submit">
                                                <img src={Details_8} alt="icon" />
                                            </button>
                                        </form>
                                    </div>
                                </div>
                                <div
                                    className="blog-block animate fadeInRight wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="300ms"
                                >
                                    <div className="category-widget">
                                        <h4>Categories</h4>
                                        <ul>
                                            <li>
                                                <Link to="#">Accounting</Link> <span>+</span>
                                            </li>
                                            <li>
                                                <Link to="#">Business</Link> <span>+</span>
                                            </li>
                                            <li>
                                                <Link to="#">Economics</Link> <span>+</span>
                                            </li>
                                            <li>
                                                <Link to="#">Investment</Link> <span>+</span>
                                            </li>
                                            <li>
                                                <Link to="#">Marketing</Link> <span>+</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div
                                    className="blog-block animate fadeInRight wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="400ms"
                                >
                                    <div className="recent-blog-widget">
                                        <h4>Recent Post</h4>
                                        <div className="recent-blog-widget-item">
                                            <img
                                                src={Details_9}
                                                alt="blog-image"
                                            />
                                            <div className="recent-blog-widget-item-title">
                                                <span>18 November 2024 </span>
                                                <Link to="/BlogDetails">
                                                    Your brand is your promise to your customer{" "}
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="recent-blog-widget-item">
                                            <img
                                                src={Details_10}
                                                alt="blog-image"
                                            />
                                            <div className="recent-blog-widget-item-title">
                                                <span>September 20, 2023</span>
                                                <Link to="/BlogDetails">
                                                    Process of giving a meaning to specific organization
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="recent-blog-widget-item">
                                            <img
                                                src={Details_11}
                                                alt="blog-image"
                                            />
                                            <div className="recent-blog-widget-item-title">
                                                <span>September 20, 2023</span>
                                                <Link to="/BlogDetails">
                                                    New Consulting For Business Finance
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="blog-block animate fadeInRight wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="500ms"
                                >
                                    <div className="tag-widget">
                                        <h4>Our Tags</h4>
                                        <ul>
                                            <li>
                                                <Link to="#">marketing</Link>
                                            </li>
                                            <li>
                                                <Link to="#">Business</Link>
                                            </li>
                                            <li>
                                                <Link to="#">Consulting</Link>
                                            </li>
                                            <li>
                                                <Link to="#">Finance</Link>
                                            </li>
                                            <li>
                                                <Link to="#">Bank</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div
                                    className="blog-block cta-widget animate fadeInRight wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="600ms"
                                >
                                    <div className="bolg-cta-widget">
                                        <h4>Request a Call Back</h4>
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                            eiusmod tempor incididunt.
                                        </p>
                                        <Link to="tel:(234) 109-6666" className="tel">
                                            (234) 109-6666
                                        </Link>
                                        <Link to="" className="btn btn-secondary btn-theme">
                                            Contact Us +
                                        </Link>
                                    </div>
                                </div>
                                <div
                                    className="blog-block mb-0 animate fadeInRight wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="700ms"
                                >
                                    <div className="insta-post-widget">
                                        <h4>Instagram Post</h4>
                                        <div className="insta-post">
                                            <Link to="#" className="insta-image">
                                                <img
                                                    src={Details_12}
                                                    alt="insta-image"
                                                />
                                            </Link>
                                            <Link to="#" className="insta-image">
                                                <img
                                                    src={Details_13}
                                                    alt="insta-image"
                                                />
                                            </Link>
                                            <Link to="#" className="insta-image">
                                                <img
                                                    src={Details_14}
                                                    alt="insta-image"
                                                />
                                            </Link>
                                            <Link to="#" className="insta-image">
                                                <img
                                                    src={Details_15}
                                                    alt="insta-image"
                                                />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Details
